import styles from './FloorplanCard.module.css';

export default function FloorplanCard({ 
    image, 
    homeType, 
    planName, 
    beds, 
    baths, 
    garage, 
    sqft, 
    stories,
    onSelect 
}) {
    return (
        <div className={styles.card}>
            <div className={styles.imageContainer}>
                <img src={image} alt={planName} className={styles.image} />
            </div>
            
            <div className={styles.content}>
                <p className={styles.homeType}>{homeType}</p>
                <h3 className={styles.planName}>{planName}</h3>
                <div className={styles.divider} />
                
                <div className={styles.specs}>
                    <div className={styles.specItem}>{beds}</div>
                    <div className={styles.specItem}>{baths}</div>
                    <div className={styles.specItem}>{garage}</div>
                    <div className={styles.specItem}>{sqft}</div>
                    <div className={styles.specItem}>{stories}</div>
                </div>
                
                <button className={styles.selectButton} onClick={onSelect}>
                    Select Plan
                </button>
            </div>
        </div>
    );
}
